export const updatePaymentRowsWithCheckInOut = (stayRows, paymentRows, setPaymentRows) => {
    const updatedPaymentRows = [...paymentRows];
    const firstCheckIn = stayRows[0]?.checkIn;
    const lastCheckOut = stayRows[stayRows.length - 1]?.checkOut;
        if(firstCheckIn && lastCheckOut){
            for (let i = 0; i < paymentRows.length; i++) {
               updatedPaymentRows[i].enterDate = firstCheckIn;
               updatedPaymentRows[i].sortDate = lastCheckOut;
            }
        }
    setPaymentRows([...updatedPaymentRows]); 
};
